// import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#0d1117',//colors.indigo[900],
    main: "#191d22",//"#313f44",//"#343a40",//colors.indigo[500],
    light: '',//colors.indigo[100]
  },
  secondary: {
    contrastText: white,
    dark: '#FFFFFF',//colors.blue[900],
    main: '#FFFFFF',//colors.blue['A400'],
    light: '#FFFFFF',//colors.blue['A400']
  },
  success: {
    contrastText: white,
    dark: '#FFFFFF',//colors.green[900],
    main: '#FFFFFF',//colors.green[600],
    light: '#FFFFFF',//colors.green[400]
  },
  info: {
    contrastText: white,
    dark: '#FFFFFF',//colors.blue[900],
    main: '#FFFFFF',//colors.blue[600],
    light: '#FFFFFF',//colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: '#FFFFFF',//colors.orange[900],
    main: '#FFFFFF',//colors.orange[600],
    light: '#FFFFFF',//colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: '#FFFFFF',//colors.red[900],
    main: '#FFFFFF',//colors.red[600],
    light: '#FFFFFF',//colors.red[400]
  },
  text: {
    primary: '#c7d3d7',//"#313f44",// colors.blueGrey[900],
    secondary: "#a8abac",//colors.blueGrey[600],
    link: "#17a2b8",//colors.blue[600]
  },
  background: {
    default: "#121212",//'#F5F5F5',//'#F4F6F8',
    paper: white,
    main: "#343a40"
  },
  icon: "#258bad",//colors.blueGrey[600],
  divider: "#f5f5f5",///colors.grey[200]
};
